module.exports = __webpack_public_path__ + "static/greybunny5-39880b52d0cb0d33df2dcab344f18652.png";